const PlusBoldIcon = ({ size = 29, fill = '#B50A0F' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9583 15.1654H15.9583V22.1654H13.625V15.1654H6.625V12.832H13.625V5.83203H15.9583V12.832H22.9583V15.1654Z"
        fill={fill}
      />
    </svg>
  );
};

export default PlusBoldIcon;
